import React from "react";
import { useUtil } from "../../contexts/UtilContext";

const CookiePolicyBanner = () => {
  const { cookiePolicy, updateCookiePolicy } = useUtil();

  const acceptAllCookies = () => {
    updateCookiePolicy("all");
  };

  const acceptNecessaryOnly = () => {
    updateCookiePolicy("necessary_only");
  };

  const customizeSettings = () => {
    // Implement customize settings functionality
    console.log("Customize settings clicked");
  };

  if (cookiePolicy !== "none") return null; // Don't show banner if the user has already chosen a preference

  return (
    <div id="cookie-consent-banner" style={bannerStyle}>
      <div style={iconContainerStyle}>
        <div style={cookieIconStyle}></div>
      </div>
      <p style={textStyle}>
        By clicking "Accept all cookies", you agree Stack Exchange 
        can store cookies on your device and disclose information in
        accordance with our <a href="/cookie-policy" style={linkStyle}>Cookie Policy</a>.
      </p>
      <div style={buttonContainerStyle}>
        <button onClick={acceptAllCookies} style={primaryButtonStyle}>
          Accept all cookies
        </button>
        <button onClick={acceptNecessaryOnly} style={secondaryButtonStyle}>
          Necessary cookies only
        </button>
      </div>
      <button onClick={customizeSettings} style={tertiaryButtonStyle}>
        Customize settings
      </button>
    </div>
  );
};

const bannerStyle = {
  position: "fixed",
  bottom: "20px",
  left: "50%",
  transform: "translateX(-50%)",
  background: "#202224",
  padding: "20px",
  boxSizing: "border-box",
  zIndex: "100",
  width: "475px",
  maxWidth: "90%",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
  color: "#fff",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
};

const iconContainerStyle = {
  marginBottom: "10px",
};

const cookieIconStyle = {
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  border: "2px solid #3b85e3",
  position: "relative",
  display: "inline-block",
  boxSizing: "border-box",
  backgroundImage: "radial-gradient(circle, transparent 40%, #3b85e3 40%, #3b85e3 44%, transparent 44%), radial-gradient(circle at 65% 40%, transparent 40%, #3b85e3 40%, #3b85e3 44%, transparent 44%), radial-gradient(circle at 35% 65%, transparent 40%, #3b85e3 40%, #3b85e3 44%, transparent 44%)",
  backgroundSize: "100%, 50%, 35%",
  backgroundRepeat: "no-repeat",
};

const textStyle = {
  margin: "0 0 15px 0",
  fontSize: "14px",
  lineHeight: "1.5",
  textAlign: "left",
};

const linkStyle = {
  color: "#3b85e3",
  textDecoration: "none",
};

const buttonContainerStyle = {
  display: "flex",
  width: "100%",
  gap: "10px",
  marginBottom: "10px",
};

const primaryButtonStyle = {
  flex: "1",
  padding: "10px 15px",
  borderRadius: "4px",
  border: "none",
  background: "#3b85e3",
  color: "white",
  fontSize: "13px",
  cursor: "pointer",
};

const secondaryButtonStyle = {
  flex: "1",
  padding: "10px 15px",
  borderRadius: "4px",
  border: "none",
  background: "#d3e4fc",
  color: "#202224",
  fontSize: "13px",
  cursor: "pointer",
};

const tertiaryButtonStyle = {
  width: "100%",
  padding: "10px 15px",
  borderRadius: "4px",
  border: "1px solid #555",
  background: "transparent",
  color: "white",
  fontSize: "13px",
  cursor: "pointer",
};

export default CookiePolicyBanner;
